export default __webpack_public_path__ + "static/media/logo-dark.f2b62ab0.png";